// extracted by mini-css-extract-plugin
export default {"buttonNoBorder":"customButton_buttonNoBorder__qjQJ4","buttonGradient":"customButton_buttonGradient__mbuPK","buttonOnlyBorder":"customButton_buttonOnlyBorder__eHrPW"};